export default __webpack_public_path__ + "_/images/freespins/freespins-30-dcf4cc400d0c7d15514289e625510534b1181024b740cd94fc76520bb2e065e6.png";